module.exports = __webpack_public_path__ + "img/just-get-here-solitude.jpg";